import * as React from 'react';
import Button from "@components/common/button/Button";
import Typography from '@material-ui/core/Typography';
import {addDays, formatDate} from '@helpers/DateHelper';
import {Popover} from '@material-ui/core';
import TranslateNew from "@translate/TranslateNew";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Input from "@components/common/input/input.component";
import {WithStyles, withStyles} from '@material-ui/core/styles';
import {GuideStyles} from '../guide.styles';
import VVFullDatePicker from '@components/common/timepicker/VVFullDatePicker';
import { styleColors } from 'src/main.style';

const tn: TranslateNew = TranslateNew.getInstance();


interface IStepStartDateProps extends WithStyles<typeof GuideStyles> {
    step: number;
    progress?: number | undefined;
    setStep: (step: number) => void;
    setDate: (start: Date, end:Date) => void;
    style?:React.CSSProperties;
    isOnboarding:boolean;
}

interface IStepStartDateState {
    date: Date;
    endDate :Date;
    edit:"start"|"end"|undefined;
}

class StepStartDate extends React.Component<IStepStartDateProps, IStepStartDateState> {


    public state: IStepStartDateState = {
        date: new Date(),
        endDate: new Date(((new Date()).getFullYear()+2)+"-12-31"),
        edit:undefined,
    };

    private startRef:React.RefObject<HTMLDivElement> = React.createRef();
    private endRef:React.RefObject<HTMLDivElement> = React.createRef();

    public updateDate(startD:Date|undefined, endD:Date|undefined) {

        // console.log(startD,endD)
        const date = startD !== undefined
            ?startD
            :new Date(Math.min(this.state.date.getTime(),endD!.getTime()))

        const endDate = endD !== undefined
            ?endD
            :new Date(Math.max(this.state.endDate.getTime(),startD!.getTime()))

        this.setState({date,endDate})
    }

    public verifyBeforeProceed = () => {
        const {setStep, setDate} = this.props;
        const {date, endDate} = this.state;

        if (!date || !endDate || date.getTime() > endDate.getTime()) return;

        setDate(date, endDate);
        setStep(2);
    }

    public resetToDefault = () => {
        const {setStep} = this.props;
        this.setState({date: new Date(), endDate: new Date(((new Date()).getFullYear()+2)+"-12-31")});
        setStep(0);
    }

    public render() {
        const {classes, step} = this.props;
        const {date, endDate} = this.state;

        const isSliding = step === 1 ? `${classes.default}` : `${classes.slide}`;

        return (
            <div className={classes.container}  style={this.props.style}>
                <div className={classes.topBarWithBackButton}>
                    <Button variant="text" onClick={this.resetToDefault} className={classes.backButton}>
                        <ArrowBackIcon fontSize="small"/>
                        <span style={{flex: 1}}>{tn.lang.back}</span>
                    </Button>
                </div>
                <div className={classes.topContent}>
                    <Typography variant="h2" style={{color:styleColors.greyDark2}}>{tn.lang.newCalendarStartDateTitle}</Typography>
                </div>
                <div className={classes.formMiddleContentChildren} >   
                    <div className={classes.inputStyle}
                        ref={this.startRef}
                        onClick={() => this.setState({edit:"start"})}
                    >{formatDate(date)}</div>
                    <Popover 
                        disableScrollLock={true}
                        anchorEl={this.startRef.current}
                        onClose={() => {this.setState({edit:undefined});}}
                        open={(this.state.edit === "start")}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                        }}
                    >
                        <VVFullDatePicker
                            open={(this.state.edit === "start")}
                            date={this.state.date}
                            setDate={(dater:Date) => this.updateDate(dater, undefined)}
                        />
                    </Popover>

                    <Typography variant="h3" style={{marginTop:'40px', color:styleColors.greyDark2}}>{tn.lang.newCalendarEndDateTitle}</Typography>
                    <div className={classes.inputStyle}
                        ref={this.endRef}
                        onClick={() => this.setState({edit:"end"})}
                    >{formatDate(endDate)}</div>

                    <Popover 
                        disableScrollLock={true}
                        anchorEl={this.endRef.current}
                        onClose={() => {this.setState({edit:undefined});}}
                        open={(this.state.edit === "end")}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                        }}
                    >
                        <VVFullDatePicker
                            open={(this.state.edit === "end")}
                            date={this.state.endDate}
                            setDate={(dater:Date) => this.updateDate(undefined, dater)}
                        />
                    </Popover>
                </div>
                <div className={classes.formBottomContent}>
                    <Button
                        variant="contained"
                        color="primary"
                        size="large"
                        fullWidth={true}
                        onClick={() => this.verifyBeforeProceed()}>
                        {tn.lang.continue}
                    </Button>
                </div>
            </div>
        );
    }
}

export default withStyles(GuideStyles)(StepStartDate);



// WEBPACK FOOTER //
// ./src/components/guide/steps/StepStartDate.tsx